<div>
  <button
    style="top: 9px"
    [matMenuTriggerFor]="menu"
    mat-icon-button
    matTooltip="Manage tools visibility"
    aria-label="Manage tools visibility"
  >
    <mat-icon>more_horiz</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <span
      style="
        display: flex;
        font-weight: bold;
        font-size: 18px;
        justify-content: center;
        margin: 10px;
      "
      >Tools Visibility Management</span
    >
    <mat-divider />
    <mat-list class="hoverable-list">
      @for (tool of toolList; track tool.title) {
        <mat-list-item
          *ngIf="hasPermission(tool)"
          (click)="toggleShowHideTool($event, tool)"
          [matTooltip]="tool.title"
          [matTooltipShowDelay]="1000"
        >
          <p matListItemTitle>
            {{ tool.title }}
          </p>
          <mat-icon matListItemIcon style="color: black">{{
            tool.hidden ? 'visibility_off' : 'visibility_on'
          }}</mat-icon>
        </mat-list-item>
      }
    </mat-list>
  </mat-menu>
</div>
